// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, createHook } from '@atlassian/react-sweet-state';
import { actions } from './actions.tsx';
import { fallbackValue } from './constants.tsx';
import type { State } from './types.tsx';

type Actions = typeof actions;

export const initialState: State = {
	isInitialised: false,
	data: fallbackValue,
	isLoading: false,
};

const store = createStore<State, Actions>({
	name: 'RequestTypeFieldsLayoutUserPreference',
	initialState,
	actions,
});

export const useRequestTypeFieldsLayoutPreference = createHook<State, Actions>(store);
